var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    transform: "translate(6 6)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#E21B1B"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M16.497 17.433c-.238 0-.475-.09-.656-.272L6.843 8.163c-.363-.363-.363-.95 0-1.313.363-.362.95-.362 1.313 0l8.998 8.998c.363.363.363.95 0 1.313-.182.181-.42.272-.657.272z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M7.5 17.433c-.239 0-.476-.09-.657-.272-.363-.363-.363-.95 0-1.313L15.84 6.85c.362-.362.95-.362 1.312 0 .363.363.363.95 0 1.313l-8.997 8.998c-.182.181-.42.272-.657.272z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorRed);
export default __webpack_public_path__ + "static/media/error-red.4e8940d82966152923a80800f2a274cc.svg";
export { ForwardRef as ReactComponent };